<template>
	<div>

	<el-main>
		<!-- 把整体看作一个table -->
		<el-col class="el-col">
			<ul>
				<li>
					<h2 class="header_h2">商品分类管理</h2>
				</li>
				<li>
					<el-button type="primary" style="margin-left:10px;float: left;" @click="baonewAdd">新增</el-button>
					<el-input v-model="select_word" placeholder="分类名称" style="display:inline-block;width:150px;float: left;"></el-input>
				</li>
			</ul>
			<el-table border ref="multipleTable" tooltip-effect="dark" :data="data.slice((currentPage-1)*pagesize,currentPage*pagesize)">
				<el-table-column prop="typename" label="分类名称" width="160px"></el-table-column>
				<el-table-column prop="ordernum" label="排序号"></el-table-column>
				<el-table-column prop="memo" label="备注"></el-table-column>
				<el-table-column label="操作"  fixed="right">
					<template slot-scope="scope">              
						<el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit" type="text" size="small">编辑</el-button>

					</template>
				</el-table-column>
			</el-table>
			<!-- </el-container> -->
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
						 :page-sizes="[5, 10, 20, 40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="data.length"></el-pagination>
					</div>
				</template>
			</el-footer>
		</el-col>
		<!-- 修改信息 -->
		<el-dialog title="修改信息" :visible.sync="bao1edit">
			<el-form :model="EditInfo" ref="EditInfo" label-width="100px">
				<el-form-item label="分类名称">
					<el-input v-model="EditInfo.typename"></el-input>
				</el-form-item>
				<el-form-item label="排序号">
					<el-input type='number' v-model="EditInfo.ordernum"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="EditInfo.memo"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1editSure">确定</el-button>
					<el-button @click.native="bao1edit = false">取消</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>

		<!-- ----新增信息---- -->
		<el-dialog title="新增信息" :visible.sync="bao1newadd">
			<el-form :model="AddInfo" ref="AddInfo" label-width="100px">
				<el-form-item label="分类名称">
					<el-input v-model="AddInfo.typename"></el-input>
				</el-form-item>
				<el-form-item label="排序号">
					<el-input type='number' v-model="AddInfo.ordernum"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="AddInfo.memo"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1AddSure">确定</el-button>
					<el-button @click.native="bao1newadd = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		
		
	</el-main>
	<el-container>
		<RouterView></RouterView>
	</el-container>
	</div>
</template>



<script>
	import goods from '../../apifunction/Goods.js'
	export default {
		created() {
			this.user=this.$myglobal.getUserInfo();
			this.InitData();
		},
		data() {
			return {
				user:null,
				goodstypelist: [],
				currentPage: 1,
				pagesize: 5,
				bao1edit: false,
				bao1newadd: false,
				idx: null,
				//   通过姓名查询
				select_word: "",
				EditInfo: {
					id:'',
					corpid: '',
					typename: '',
					ordernum: '1',
					operate_date: '',
					operate_user: '',
					memo: ''
				},
				AddInfo: {
					id:'',
					corpid: '',
					typename: '',
					ordernum: '1',
					operate_date: '',
					operate_user: '',
					memo: ''
				},
				
			};
		},
		methods: {
			//   得到所有的数据---------------
			InitData() {
				goods.GetGoodsTypeByCorpid(this.user.corpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data == 'null')
								this.goodstypelist = [];
							else
								this.goodstypelist = JSON.parse(ent.Data);

						} else
							this.$message.info(ent.Msg);
					})
			},
			// 分页------------------------
			// 初始页currentPage、初始每页数据数pagesize和数据data
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			// 操作界面 ----------- 编辑-----通过改变数据并且驱动视图更新$set方法
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;

				this.EditInfo = {
					id:row.id,
					corpid: row.corpid,
					typename: row.typename,
					ordernum: row.ordernum,
					operate_date: row.operate_date,
					operate_user: row.operate_user,
					memo: row.memo
				};
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {
				goods.EditGoodsType(this.EditInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.goodstypelist.splice(this.idx, 1, this.EditInfo)
							this.bao1edit = false;
							this.$message.success("修改成功");

						} else
							this.$message.info(ent.Msg);
					})

			},
			// 新增按钮-----
			baonewAdd() {
				this.bao1newadd = true;
				this.AddInfo.typename = '';
				this.AddInfo.ordernum = '1';
				this.AddInfo.memo = '';
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				//this.$refs.AddInfo 这个数据上有一个validate方法,这个方法可以判断数据是否存在
				if (this.AddInfo.typename == '') {
					this.$message.success("分类名称不能为空！");
					return;
				}
				this.AddInfo.corpid = this.user.corpid;
				this.AddInfo.id = this.CommonFun.NewGuid();
				this.AddInfo.operate_date = this.CommonFun.GetNowDateTime();
				this.AddInfo.operate_user =this.user.id;
				goods.AddGoodsType(this.AddInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.goodstypelist.unshift(this.AddInfo);
							this.bao1newadd = false;
							this.$message.success("新增成功");

						} else
							this.$message.info(ent.Msg);
					})
			},
		},
		computed: {
			data() {
				return this.goodstypelist.filter(item => {

					if (item.typename.indexOf(this.select_word) > -1) {
						return item;
					}
				});
			}
		}
	};
</script>


<style scoped>

</style>
